import React, { CSSProperties } from 'react'

import classNames from 'classnames'
import { useEffectOnce } from 'react-use'

import CommonCloseIcon from '@local/assets/icons/common_icon_close.svg'
import FailedWarningIcon from '@local/assets/icons/failed_icon_warning.svg'
import PanelRefreshIcon from '@local/assets/icons/panel_icon_refresh.svg'

import Clickable from '@web/components/Clickable'
import { useNavigation } from '@web/hooks/useNavigation'
import { neloLogger } from '@web/libs/utils'
import { ClickEvent } from '@web/types'

import styles from './index.module.scss'

interface Props {
  neloLog?: Parameters<typeof neloLogger>
  onClickCloseButton?: (e?: ClickEvent) => void
  onClickBackButton?: (e?: ClickEvent) => void
  hideCloseButton?: boolean
  style?: CSSProperties
  refreshClickCode?: string
}

const ErrorPage = ({ style, hideCloseButton, neloLog, onClickCloseButton, refreshClickCode }: Props) => {
  const { back } = useNavigation()

  const handleClose = () => {
    if (onClickCloseButton) {
      onClickCloseButton()
    } else {
      back()
    }
  }

  useEffectOnce(() => {
    if (!neloLog) return

    neloLogger(...neloLog)
  })

  return (
    <>
      <div className={classNames(styles.content)} style={style}>
        <div className={styles.info_area}>
          <div className={styles.popup_tit_area}>
            <FailedWarningIcon className={styles.icon_error} aria-hidden="true" />
            <div className={styles.tit}>
              <strong>불편을 드려 죄송합니다.</strong>
            </div>
            <div className={styles.txt}>다시, 시도해 주실래요?</div>
          </div>
        </div>
        <div className={styles.bottom_btn_area}>
          <div className={styles.btn_wrapper}>
            <Clickable className={styles.btn} nClickCode={refreshClickCode} onClick={() => window.location.reload()}>
              <PanelRefreshIcon className={styles.icon_refresh} aria-hidden="true" />
              새로고침
            </Clickable>
          </div>
        </div>
      </div>
      {!hideCloseButton && (
        <Clickable className={styles.btn_close} onClick={handleClose}>
          <CommonCloseIcon className={styles.icon} aria-hidden="true" />
          <span className="place_blind">닫기</span>
        </Clickable>
      )}
    </>
  )
}

export default ErrorPage
